import { Route, Routes } from "react-router-dom";
import { AppShell } from "./components/layout/AppShell";
import { RequireSession } from "./features/auth/RequireSession";
import { CampaignPage } from "./routes/CampaignPage";
import { CampaignsPage } from "./routes/CampaignsPage";
import { ContentPage } from "./routes/ContentPage";
import { HomePage } from "./routes/HomePage";
import { LocationsPage } from "./routes/LocationsPage";
import { ProductPage } from "./routes/ProductPage";
import { ProductsPage } from "./routes/ProductsPage";
import { CollectionPage } from "./routes/CollectionPage";
import { CollectionsPage } from "./routes/CollectionsPage";
import { DocsPage } from "./routes/DocsPage";
import { ExperimentsPage } from "./routes/ExperimentsPage";
import { SettingsPage } from "./routes/SettingsPage";

export const App = () => (
	<RequireSession>
		<AppShell>
			<Routes>
				<Route path="/" element={<HomePage />} />
				<Route path="/campaigns" element={<CampaignsPage />} />
				<Route path="/campaigns/:campaignId" element={<CampaignPage />} />
				<Route path="/content" element={<ContentPage />} />
				<Route path="/experiments" element={<ExperimentsPage />} />
				<Route path="/products" element={<ProductsPage />} />
				<Route path="/products/:productId" element={<ProductPage />} />
				<Route path="/collections" element={<CollectionsPage />} />
				<Route path="/collections/:collectionId" element={<CollectionPage />} />
				<Route path="/locations" element={<LocationsPage />} />
				<Route path="/docs" element={<DocsPage />} />
				<Route path="/settings" element={<SettingsPage />} />
				<Route path="*" element={<HomePage />} />
			</Routes>
		</AppShell>
	</RequireSession>
);
